import React, { createContext, useEffect, useState } from "react";
import {
    AssetSignalsModel,
    IndexModel,
    ProjectDto,
    RightPanelsModel,
    UserNotificationDto,
} from "../api/APIClient";
import { notificationsService } from "../api/Services";
import { ProjectContext } from "./Project/Context/ProjectContext";
import { ViewerMode } from "./Project/Viewer/ForgeViewer/BIMDigitalTwinViewer/Utils";

let defaulValues;

const PanelProjectContext = createContext(defaulValues);

interface IPanelViewerProviderProps {
    children: React.ReactNode;
}

interface IObjTest {
    xcoord: number;
    ycoord: number;
    data: AssetSignalsModel;
}

const PanelProjectProvider = ({ children }: IPanelViewerProviderProps): JSX.Element => {
    const [project, setProject] = useState<ProjectDto>(
        React.useContext<ProjectDto>(ProjectContext)
    );
    const [notifications, setNotifications] = useState<UserNotificationDto[]>([]);
    const [notificationsCount, setNotificationsCount] = useState(0);
    const [redirectCommentsPanel, setRedirectCommentsPanel] = useState<boolean>(false);
    const [isViewerReady, setisViewerReady] = useState<boolean>(false);
    const [view, setView] = React.useState("");
    const [hoveredDeviceInfo, setHoveredDeviceInfo] = useState<IObjTest | undefined>(undefined);
    const [rightPanelsData, setRightPanelsData] = useState<RightPanelsModel | undefined>({});
    const [isRightPanelOpen, setIsRightPanelOpen] = useState<boolean>(false);
    const [isViewerLoading, setIsViewerLoading] = useState<boolean>(false);
    const [isRenderingItems, setIsRenderingItems] = useState<boolean>(false);
    const [dbidFromSelection, setDbidFromSelection] = useState<number[]>([]);
    const [assetSelection, setAssetSelection] = useState<IndexModel | undefined>({});
    const [viewerMode, setViewerMode] = useState<ViewerMode>(ViewerMode.AssetInfo);
    const [isWorkOrderOpen, setIsWorkOrderOpen] = useState<boolean>(false);
    const [dbidsToRender, setDbidsToRender] = useState<number[]>([]);
    const [rightButtonsType, setRightButtonsType] = useState<string>("");

    React.useEffect(() => {
        notificationsService.getUnreadNotifications(project.id).then((resp) => {
            if (resp) {
                setNotifications(resp.data);
                setNotificationsCount(resp.data.length);
            } else {
                setNotifications([]);
                setNotificationsCount(0);
            }
        });
    }, [project]);

    return (
        /* Extracting all the variables through the value prop */
        <PanelProjectContext.Provider
            value={{
                project,
                setProject,
                notifications,
                setNotifications,
                notificationsCount,
                setNotificationsCount,
                redirectCommentsPanel,
                setRedirectCommentsPanel,
                isViewerReady,
                setisViewerReady,
                view,
                setView,
                setDbidsToRender,
                dbidsToRender,
                hoveredDeviceInfo,
                setHoveredDeviceInfo,
                rightPanelsData,
                setRightPanelsData,
                isRightPanelOpen,
                setIsRightPanelOpen,
                isViewerLoading,
                setIsViewerLoading,
                isRenderingItems,
                setIsRenderingItems,
                dbidFromSelection,
                setDbidFromSelection,
                assetSelection,
                setAssetSelection,
                viewerMode,
                setViewerMode,
                isWorkOrderOpen,
                setIsWorkOrderOpen,
                rightButtonsType,
                setRightButtonsType,
            }}
        >
            {children}
        </PanelProjectContext.Provider>
    );
};

export { PanelProjectProvider };

export default PanelProjectContext;
